import { api } from '../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchUpcomingEvents = createAsyncThunk(
  'events/fetchUpcomingEvents',
  async (limit) => {
    const response = limit ? await api.get(`/events?limit=${limit}`) : await api.get(`/events`);
    let eventList = Array.isArray(response.data) ? response.data : [];

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    eventList = [...eventList].sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      const isAFuture = dateA >= today;
      const isBFuture = dateB >= today;

      if (isAFuture && !isBFuture) return -1;
      if (!isAFuture && isBFuture) return 1;

      return Math.abs(dateA - today) - Math.abs(dateB - today);
    });

    return eventList;
  }
);

const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpcomingEvents.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUpcomingEvents.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchUpcomingEvents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectAllEvents = (state) => state.events.items;
export const selectEventsStatus = (state) => state.events.status;
export const selectEventsError = (state) => state.events.error;

export default eventsSlice.reducer;
